import InputField from "../../../components/InputField";
import SelectField from "../../../components/SelectField";
import Toggle from "../../../components/Toggle";

function Checkbox({ label, checked, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 16px",
        backgroundColor: checked ? "rgba(196, 93, 62, 0.05)" : "#fdfbf7",
        borderRadius: "10px",
        border: `2px solid ${checked ? "rgba(196, 93, 62, 0.2)" : "#e8e0d4"}`,
        cursor: "pointer",
        transition: "all 0.2s ease",
        flex: "1 1 45%",
        minWidth: "180px",
      }}
      onClick={onChange}
    >
      <div style={{
        width: "20px",
        height: "20px",
        borderRadius: "4px",
        border: `2px solid ${checked ? "#c45d3e" : "#d4cdc0"}`,
        backgroundColor: checked ? "#c45d3e" : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        transition: "all 0.2s ease",
      }}>
        {checked && <span style={{ color: "#fff", fontSize: "13px", fontWeight: 700, lineHeight: 1 }}>&#10003;</span>}
      </div>
      <span style={{ fontSize: "14px", fontWeight: 500, color: "#2d2418", fontFamily: "'DM Sans', sans-serif" }}>{label}</span>
    </div>
  );
}

export default function ConditiiStep({ data, errors, update, setField }) {
  const toggleGarantie = (field) => () => {
    update(field)(!data[field]);
    update("garantieComponente")("");
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <SelectField
          label="Stare tehnica"
          value={data.stareTehnica}
          onChange={update("stareTehnica")}
          options={[
            { value: "foarte buna", label: "Foarte buna" },
            { value: "buna", label: "Buna" },
            { value: "acceptabila", label: "Acceptabila" },
          ]}
        />
      </div>

      <Toggle label="ITP in termen" description="Autovehiculul are inspectia tehnica periodica valabila" checked={!!data.itpValid} onChange={() => update("itpValid")(!data.itpValid)} />
      <Toggle label="RCA in termen" description="Autovehiculul are asigurarea RCA valabila" checked={!!data.rcaValid} onChange={() => update("rcaValid")(!data.rcaValid)} />
      <Toggle label="Liber de sarcini" description="Autovehiculul este liber de orice sarcini sau grevari" checked={!!data.liberSarcini} onChange={() => update("liberSarcini")(!data.liberSarcini)} />

      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <SelectField
          label="Garantie vicii ascunse"
          value={data.garantieActiva ? "cu_garantie" : "fara_garantie"}
          onChange={(e) => update("garantieActiva")(e.target ? e.target.value === "cu_garantie" : e === "cu_garantie")}
          options={[
            { value: "fara_garantie", label: "Fara garantie (vandut ca atare)" },
            { value: "cu_garantie", label: "Cu garantie (specifica)" },
          ]}
        />
      </div>
      {data.garantieActiva && (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            <SelectField
              label="Durata garantie"
              value={data.garantieLuni}
              onChange={update("garantieLuni")}
              options={[
                { value: "1", label: "1 luna" },
                { value: "3", label: "3 luni" },
                { value: "6", label: "6 luni" },
              ]}
              half
            />
          </div>
          <div>
            <label style={{
              display: "block",
              fontSize: "13px",
              fontWeight: 600,
              color: "#4a3f35",
              marginBottom: "8px",
              fontFamily: "'DM Sans', sans-serif",
              letterSpacing: "0.02em",
            }}>
              Ce acopera garantia *
            </label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              <Checkbox label="Motor" checked={!!data.garantieMotor} onChange={toggleGarantie("garantieMotor")} />
              <Checkbox label="Cutie de viteze" checked={!!data.garantieCutie} onChange={toggleGarantie("garantieCutie")} />
              <Checkbox label="Sistem de franare" checked={!!data.garantieFranare} onChange={toggleGarantie("garantieFranare")} />
              <Checkbox label="Alte componente" checked={!!data.garantieAlte} onChange={toggleGarantie("garantieAlte")} />
            </div>
            {data.garantieAlte && (
              <div style={{ marginTop: "10px" }}>
                <InputField
                  label="Specificati componentele"
                  value={data.garantieAlteText}
                  onChange={update("garantieAlteText")}
                  placeholder="ex: turbosuflanta, alternator..."
                  required
                  error={errors.garantieAlteText}
                />
              </div>
            )}
            <p style={{ fontSize: "12px", color: "#8a7e70", margin: "8px 0 0 0", fontFamily: "'DM Sans', sans-serif", fontStyle: "italic" }}>
              Garantia este limitata la componentele selectate si nu acopera uzura normala.
            </p>
            {errors.garantieComponente && (
              <p style={{ fontSize: "12px", color: "#c45d3e", margin: "6px 0 0 0" }}>{errors.garantieComponente}</p>
            )}
          </div>
        </>
      )}

      <Toggle
        label="Martori"
        description="Contractul va include sectiune de semnaturi pentru 2 martori"
        checked={!!data.martori}
        onChange={() => update("martori")(!data.martori)}
      />
    </div>
  );
}
